export const PlatformType = {
  Ios: 'ios',
  Android: 'android',
  Web: 'web',
  Electron: 'electron'
}